"use client";

import styles from "./scroll-down.btn.module.scss";
import classNames from "classnames";
import { useUIStore } from "@/stores/ui-states.store";
import { useStyleController } from "@/hooks/useStyleController.hook";
import BlessArrow from "@/components/svg/arrow";

const ScrollDownBtn = () => {
  const { introAnimationCompleted, setIsContainerExpanded } = useUIStore();
  const {
    isLinesVisible,
    refControl: { scrollDownTarget },
  } = useStyleController();

  const handleScrollDown = () => {
    scrollDownTarget.current?.scrollIntoView({
      block: "center",
      behavior: "smooth",
    });
  };

  return (
    <button
      onMouseOver={() => setIsContainerExpanded(true)}
      onMouseOut={() => setIsContainerExpanded(false)}
      onClick={handleScrollDown}
      className={classNames(
        styles.scrollDownBtn,
        introAnimationCompleted && isLinesVisible && styles.visible,
      )}
    >
      <BlessArrow />
    </button>
  );
};

export default ScrollDownBtn;
